module.exports = __webpack_public_path__ + "img/EDIT.6ebcded3.svg";